import { render } from "./addModuleGoodsType.vue?vue&type=template&id=455b1d55&scoped=true"
import script from "./addModuleGoodsType.vue?vue&type=script&lang=js"
export * from "./addModuleGoodsType.vue?vue&type=script&lang=js"

import "./addModuleGoodsType.vue?vue&type=style&index=0&id=455b1d55&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455b1d55"]])

export default __exports__